import axios from 'axios'
import {
  getSelectedClientId,
  shouldSkipClientFilter,
} from './clientFilterStore'
import { esRutaPublica } from '../utils/registroPublico'

const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
})

// Interceptor para agregar token + filtro global de cliente
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Token ${token}`
    }
    // FormData: no usar Content-Type para que el navegador lo asigne con boundary
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type']
    }

    const clientId = getSelectedClientId()
    const url = config.url || ''
    if (clientId != null && !shouldSkipClientFilter(url, config.method)) {
      config.headers['X-Client-Id'] = String(clientId)
      const method = String(config.method || 'get').toLowerCase()
      if (method === 'get' || method === 'head' || method === 'delete') {
        const params = { ...(config.params || {}) }
        // Forzar el filtro global (gana sobre filtros locales de pantalla)
        params.client_id = clientId
        params.cliente_id = clientId
        config.params = params
      } else if (config.data instanceof FormData) {
        if (!config.data.has('client_id')) config.data.append('client_id', String(clientId))
        if (!config.data.has('cliente_id')) config.data.append('cliente_id', String(clientId))
      } else if (config.data && typeof config.data === 'object') {
        // No pisar body de creates/updates arbitrarios; solo query ya cubre listados
      }
    }

    if (process.env.NODE_ENV === 'development') {
      console.log('API Request:', {
        url: config.url,
        method: config.method,
        hasToken: !!token,
        globalClientId: clientId,
        data: config.data,
        headers: config.headers,
      })
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Interceptor para manejar errores
api.interceptors.response.use(
  (response) => {
    // Log para debugging (remover en producción)
    if (process.env.NODE_ENV === 'development') {
      console.log('API Response:', {
        status: response.status,
        url: response.config?.url,
        method: response.config?.method,
        data: response.data
      })
    }
    return response
  },
  (error) => {
    // Log para debugging (remover en producción)
    if (process.env.NODE_ENV === 'development') {
      console.error('API Error:', {
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data,
        url: error.config?.url,
        method: error.config?.method
      })
    }
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      // Desde una página pública (registro, liga de verificación, recuperar) no se manda a
      // /login: un token viejo en el navegador sacaría al invitado de donde llegó por el correo.
      if (!esRutaPublica(window.location.pathname)) {
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)

export default api

